import { isEmpty } from "lodash";
import { EventsFilterParams } from "./EventsFilter";
import IFilterEvents from "./IFilterEvents";

class CompanySitesFilter implements IFilterEvents {
  filter(params: EventsFilterParams, events: VideoStreamEvent[]): VideoStreamEvent[] {
    const { companySites } = params;
    if (!companySites || isEmpty(companySites)) return events;

    const allowedSitesByCompany: Map<string, Set<string>> = new Map(
      Object.entries(companySites).map(([companyId, siteIds]) => [companyId, new Set(siteIds)])
    );

    return events.filter((event) => {
      const allowedSites = allowedSitesByCompany.get(event.companyId);
      if (allowedSites === undefined) return true;

      return allowedSites.has(event.siteId);
    })
  }
}

export default CompanySitesFilter;
